import ToolbarPopover from "../ToolbarPopover/ToolbarPopover";
import { Counter, Text, Flex, Radio, ToolSelect } from "@theorgchartdev/storybook";
import { useRef, useState } from "react";
import * as StateLib from "@/Utils/StateLib";
import { UpdateBoxProperty } from "@/Utils/StateLib";
import { getHoverTipContent } from "@/Utils/Misc";
import { kDefaultBoxPadding, enumUpdateProperty } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";

const GutterPopover = ({ layout }) => {
  const openCtrlRef = useRef(null);
  const padding = layout.GetBoxPadding();
  let theOption = "default";
  if (padding != kDefaultBoxPadding) theOption = "custom";

  const [gutterMode, setGutterMode] = useState(theOption);

  const UpdateGutterMode = value => {
    if (value === "default") {
      UpdateGutterSize(kDefaultBoxPadding);
    }
    setGutterMode(value);
    StateLib.ReRenderCanvas();
  };

  const UpdateGutterSize = newGutterSize => {
    UpdateBoxProperty(enumUpdateProperty.boxPadding, newGutterSize);
  };

  let currentBoxGutter = layout?.GetBoxPadding();
  if (currentBoxGutter == null || isNaN(currentBoxGutter)) currentBoxGutter = kDefaultBoxPadding;

  const showCustomGutter = gutterMode === "custom";
  const inputStyles = { width: "60px" };

  const gutterTrigger = (
    <ToolSelect
      dataTestId="box-layout-editor-toolbar-gutter-btn"
      disabled={false}
      label={appstr("Gutter")}
      showArrow={false}
      size="small"
      sizeProps={{
        maxWidth: 200,
        minWidth: 50
      }}
      tooltipProps={{ ...getHoverTipContent("Gutter"), referenceOpenCtrlRef: openCtrlRef }}
    />
  );
  return (
    <ToolbarPopover
      openCtrlRef={openCtrlRef}
      icon={"gear"}
      otherPopoverProps={{
        offsetOptions: -2,
        reference: gutterTrigger,
        floatingProps: { "data-testid": "box-layout-editor-toolbar-gutter-popover" }
      }}
      key={5}
    >
      <Flex direction={"column"} gap={"12px"}>
        <Flex justifyContent={"space-between"} alignItems={"center"}>
          <Text modifier={"medium"} size={"small"}>
            {appstr("Gutter")}
          </Text>
        </Flex>
        <Flex direction={"column"} gap={"12px"} alignItems={"flex-start"}>
          <Flex direction={"column"} gap={"8px"}>
            <Radio
              id="gutter-default"
              data-testid="box-layout-editor-toolbar-gutter-default-radio"
              onChange={e => UpdateGutterMode(e.target.value)}
              value={"default"}
              label={appstr("Default")}
              checked={gutterMode == "default"}
            />
            <Radio
              id="gutter-custom"
              data-testid="box-layout-editor-toolbar-gutter-custom-radio"
              onChange={e => UpdateGutterMode(e.target.value)}
              value={"custom"}
              label={appstr("Custom")}
              checked={gutterMode == "custom"}
            />
          </Flex>
          {showCustomGutter && (
            <Counter
              key={6}
              onChange={UpdateGutterSize}
              currentValue={parseFloat(currentBoxGutter)}
              defaultValue={parseFloat(currentBoxGutter)}
              inputStyles={inputStyles}
              inputProps={{
                disabled: true,
                "data-testid": "box-layout-editor-toolbar-gutter-input"
              }}
              minValue={0}
              maxValue={40}
              size={"small"}
            />
          )}
        </Flex>
      </Flex>
    </ToolbarPopover>
  );
};

export default GutterPopover;
